import React, { Component } from 'react';
import globals from "../globals";
import Hero from "../modules/Hero/Hero";
import FiveColumn from "../modules/FiveColumn/FiveColumn";
import ImagePanel from "../modules/ImagePanel";
import HelmetDefault from "../layout/HelmetDefault";

class SmallBusinessOverview extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: '',
            subTitle: '',
            leadCopy: [],
            fiveColumn: {},
            imagePanel1: {},
            imagePanel2: {},
            seoTitle: '',
            seoDescription: '',
            dataReceived: false
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        fetch('/api/small-business/overview')
            .then(result => result.json())
            .then((result) => {
                this.setState(result);
                this.setDataReceived();
                globals.animatePageIn(this.container);
            });
    }

    setDataReceived() {
        this.setState({
            dataReceived: true
        });
    }

    render() {
        return (
            <div ref={(el) => this.container = el} style={{opacity: 0}}>
                <HelmetDefault {...this.state} />
                <Hero title={this.state.title} subTitle={this.state.subTitle} leadCopy={this.state.leadCopy} dataReceived={this.state.dataReceived} />
                <FiveColumn data={this.state.fiveColumn} />
                <ImagePanel
                    data={this.state.imagePanel1}
                    align="left"
                />
                <ImagePanel
                    data={this.state.imagePanel2}
                    align="right"
                />
            </div>
        );
    }

}

export default SmallBusinessOverview;


// WEBPACK FOOTER //
// ./resources/assets/js/pages/SmallBusiness.js